<ng-container *ngIf="viewModal">
   <app-modal></app-modal>
</ng-container>

<router-outlet />

